import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# مدیریت فیلدهای سفارشی (Custom Fields)

قابلیت **فیلدهای سفارشی** به شما این امکان را می‌دهد تا بدون نیاز به تغییر در سورس کد برنامه یا دخالت تیم برنامه‌نویسی، فیلدهای اطلاعاتی جدیدی را به موجودیت‌های مختلف سیستم (مانند فرم‌های کنترل کیفیت، فرمول‌های ساخت و انبارها) اضافه کنید. این قابلیت به صورت یکپارچه در سراسر دامنه‌های سیستم در دسترس است.

## نحوه عملکرد

سیستم از دو بخش اصلی تشکیل شده است:
1. **Target Types (نوع موجودیت):** فرم‌ها و جداولی که از قابلیت فیلدهای سفارشی پشتیبانی می‌کنند.
2. **Definitions (تعریف فیلد):** ساختار هر فیلد شامل نام، نوع ورودی، الزامی بودن و شروط نمایش.

<Alert variant="info">
  تنها مدیران ارشد سیستم و کاربرانی که دارای دسترسی `forms.manage_custom_fields` هستند می‌توانند این فیلدها را تعریف یا ویرایش کنند.
</Alert>

## راهنمای ایجاد فیلد سفارشی جدید

برای اضافه کردن یک فیلد جدید، مراحل زیر را طی کنید:

1. **انتخاب نوع موجودیت:** ابتدا از لیست کشویی بالای صفحه، موجودیتی که می‌خواهید فیلد به آن اضافه شود را انتخاب کنید.
2. **افزودن فیلد جدید:** روی دکمه `➕ افزودن فیلد جدید` کلیک کنید.
3. **تکمیل اطلاعات فیلد:**
   - **کلید (Key):** یک نام یکتا به زبان انگلیسی (مثلاً `machine_temp` یا `inspection_note`). این نام در دیتابیس ذخیره می‌شود.
   - **برچسب (Label):** نامی که به کاربر نمایش داده می‌شود (مثلاً "دمای دستگاه" یا "توضیحات بازرسی").
   - **نوع فیلد (Type):** شامل متنی، عددی، تاریخ، بله/خیر، لیست انتخابی و فایل.
   - **الزامی بودن (Required):** در صورت فعال بودن این گزینه، کاربر نمی‌تواند فرم را بدون پر کردن این فیلد ذخیره کند.
4. **شروط نمایش (نمایش شرطی):** 
   می‌توانید قوانینی تعریف کنید که این فیلد تنها در صورت مقداردهی خاصی به سایر فیلدها نمایش داده شود. این سیستم از ساختار شرط‌ساز (Rule Builder) پیچیده پشتیبانی می‌کند.

---

| نوع فیلد | کاربرد | مثال |
| :--- | :--- | :--- |
| **متن کوتاه** | ورود اطلاعات متنی یک‌خطی | شماره سریال قطعه |
| **متن بلند** | ورود توضیحات طولانی و چندخطی | توضیحات و مشکلات مشاهده‌شده |
| **عدد** | ورود مقادیر عددی قابل محاسبه | دمای کوره، وزن قطعه |
| **بله/خیر (Checkbox)** | تایید یا رد یک وضعیت | تایید ناظر کیفیت، نیاز به تعمیر؟ |
| **تاریخ** | انتخاب تاریخ از تقویم | تاریخ انقضا، تاریخ کالیبراسیون |
| **انتخابی (Select)** | انتخاب یک گزینه از یک لیست از پیش تعریف شده | رنگ (قرمز، آبی، سبز)، شیفت کاری |
| **فایل/تصویر** | بارگذاری مستندات و عکس | عکس از قطعه معیوب، فایل نقشه CAD |

## وضعیت فیلدها (فعال/غیرفعال)
شما می‌توانید به جای حذف کامل یک فیلد سفارشی (که ممکن است باعث از دست رفتن داده‌های قبلی شود)، وضعیت آن را به **غیرفعال** تغییر دهید. فیلدهای غیرفعال در فرم‌های جدید نمایش داده نخواهند شد، اما داده‌های فرم‌های قدیمی حفظ می‌شوند.

export default function Page({ children }) {
  return <Layout>{children}</Layout>;
}
